module.exports = __webpack_public_path__ + "static/img/kings.477b830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/kings.png
// module id = 20
// module chunks = 1 2 3 5 6 7 8 9